import {
  Box,
  Divider,
  Grid2,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";

const Terms = () => {
  return (
    <>
      <Typography
        sx={{
          fontWeight: "700",
          fontSize: "50px",
          lineHeight: "75px",
          color: "#474747",
          textAlign: "center",
        }}
      >
        Term of use
      </Typography>

      <Box
        sx={{
          background: "#E5EDFF",
          padding: "30px",
          borderRadius: "25px",
          marginTop: "20px",
        }}
      >
        <Grid2 container spacing={2}>
          <Grid2 item xs={12} sm={12} md={6}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              <Box>
                <Typography
                  sx={{
                    fontSize: "30px",
                    fontWeight: "600",
                    marginBottom: "20px",
                    color: "#474747",
                    lineHeight: "35px",
                  }}
                >
                  Introduction
                </Typography>
              </Box>
              <Typography>
                By accessing and using this website, you agree to comply with
                and be bound by these Terms of Use. If you do not agree to these
                terms, please do not use the site.
              </Typography>
            </Box>
          </Grid2>

          <List sx={{ width: "100%" }}>
            {/* Term 1 */}
            <ListItem alignItems="flex-start" sx={{ py: 2 }}>
              <ListItemText
                primary={
                  <Typography
                    variant="h6"
                    component="h3"
                    sx={{ fontWeight: "bold" }}
                  >
                    1. Acceptance of Terms
                  </Typography>
                }
                secondary={
                  <Typography
                    component="span"
                    variant="body1"
                    sx={{ display: "inline" }}
                  >
                    These Terms of Use are a legally binding agreement between
                    you and the website operator. By using this website, you
                    agree to these terms, including any future modifications.
                  </Typography>
                }
              />
            </ListItem>

            <Divider component="li" />

            {/* Term 2 */}
            <ListItem alignItems="flex-start" sx={{ py: 2 }}>
              <ListItemText
                primary={
                  <Typography
                    variant="h6"
                    component="h3"
                    sx={{ fontWeight: "bold" }}
                  >
                    2. Modifications to Terms
                  </Typography>
                }
                secondary={
                  <Typography
                    component="span"
                    variant="body1"
                    sx={{ display: "inline" }}
                  >
                    We reserve the right to modify or update these Terms of Use
                    at any time without prior notice. Changes will be posted on
                    this page, and the updated version will take effect
                    immediately upon posting.
                  </Typography>
                }
              />
            </ListItem>

            <Divider component="li" />

            {/* Term 3 */}
            <ListItem alignItems="flex-start" sx={{ py: 2 }}>
              <ListItemText
                primary={
                  <Typography
                    variant="h6"
                    component="h3"
                    sx={{ fontWeight: "bold" }}
                  >
                    3. Use of Website
                  </Typography>
                }
                secondary={
                  <Typography
                    component="span"
                    variant="body1"
                    sx={{ display: "inline" }}
                  >
                    You agree to use the website only for lawful purposes and in
                    accordance with these Terms of Use. You shall not use the
                    website in any way that could damage, disable, or impair the
                    website’s functionality.
                  </Typography>
                }
              />
            </ListItem>

            <Divider component="li" />

            {/* Term 4 */}
            <ListItem alignItems="flex-start" sx={{ py: 2 }}>
              <ListItemText
                primary={
                  <Typography
                    variant="h6"
                    component="h3"
                    sx={{ fontWeight: "bold" }}
                  >
                    4. User Accounts
                  </Typography>
                }
                secondary={
                  <Typography
                    component="span"
                    variant="body1"
                    sx={{ display: "inline" }}
                  >
                    If you create an account on the website, you are responsible
                    for maintaining the confidentiality of your account
                    information and for all activities that occur under your
                    account.
                  </Typography>
                }
              />
            </ListItem>

            <Divider component="li" />

            {/* Term 5 */}
            <ListItem alignItems="flex-start" sx={{ py: 2 }}>
              <ListItemText
                primary={
                  <Typography
                    variant="h6"
                    component="h3"
                    sx={{ fontWeight: "bold" }}
                  >
                    5. Content Ownership
                  </Typography>
                }
                secondary={
                  <Typography
                    component="span"
                    variant="body1"
                    sx={{ display: "inline" }}
                  >
                    All content on the website, including text, images, and
                    logos, is owned by the website's operator or it's licensors.
                    You are not granted any rights to use the content except for
                    personal, non-commercial purposes.
                  </Typography>
                }
              />
            </ListItem>
          </List>
        </Grid2>
      </Box>
    </>
  );
};

export default Terms;
